<template>
    <div id="pathways-manage-segments">
        <div class="card mb-3 table-card">
            <div class="card-header">
                <div class="row">
                    <div class="col-md-6 col-12">
                        <div v-if="selected_segments.length > 0" class="d-flex align-items-center justify-content-between w-100">
                            <div class="d-flex">
                                <span v-if="!select_all_checked" class="m-2"><strong>{{ selected_segments.length }} items selected:</strong></span>
                                <span v-else-if="!allSegmentsSelected" class="me-2">
                                    <div class="lh-1"><strong>{{ selected_segments.length }} items selected</strong></div>
                                    <div class="lh-1">
                                        <small><a href="#" @click.prevent="toggleSelectAllInTable()">(Select all {{ filtered_segment_list.length }} items in the table)</a></small>
                                    </div>
                                </span>
                                <span v-else class="m-2"><strong>{{ selected_segments.length }} items selected:</strong></span>

                                <button class="btn btn-none me-2" @click="deleteSelectedSegments()" v-if="!show_archived">
                                    <img src="/img/icons/avid-icons/archive-2.svg" class="icon" alt="">Archive
                                </button>
                                <button class="btn btn-none me-2" @click="restoreSelectedSegments()" v-if="show_archived">
                                    <img src="/img/icons/avid-icons/undo.svg" class="icon" alt="">Restore
                                </button>
                            </div>
                        </div>
                        <div v-else>
                            <h3 class="mt-2"><span v-if="show_archived">Archived </span>Audiences ({{filtered_segment_list.length}})</h3>
                        </div>
                    </div>
                    <div class="col-md-6 d-none d-md-block">
                        <div class="d-flex justify-content-end justify-self-end gap-2">
                            <div class="position-relative">
                                <input type="text" class="search-box form-control me-1 py-2" placeholder="Search by Audience Name..." aria-label="Search by Audience Name..." v-model="search_key" @input="handleFilterSelection()">
                                <i class="fa fa-search search-placeholder-icon" v-if="search_key === ''"></i>
                            </div>

                            <div class="dropdown position-relative filters-dropdown">
                                <button class="btn btn-secondary dropdown-toggle dropdown-toggle-no-btn" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                                    <img class="icon" src="/img/icons/avid-icons/filter-funnel-01.svg" alt="">
                                </button>

                                <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end p-3 overflow-visible" style="min-width: 250px;">
                                    <h4>Filters</h4>
                                    
                                    <!-- Source Filter AccordionMultiselect -->
                                    <div class="mb-3">
                                        <label class="form-label">Source</label>
                                        <AccordionMultiSelect
                                            :options="source_list"
                                            v-model="filters.source"
                                            @update:modelValue="handleFilterSelection"
                                            placeholder="Select sources..."
                                        />
                                    </div>

                                    <!-- Segment Type Filter AccordionMultiselect -->
                                    <div class="mb-3" v-if="showSegmentTypeFilter">
                                        <label class="form-label">Segment Type</label>
                                        <AccordionMultiSelect
                                            :options="segment_type_list"
                                            v-model="filters.segment_type"
                                            @update:modelValue="handleFilterSelection"
                                            placeholder="Select segment types..."
                                        />
                                    </div>

                                    <!-- Audience Type Filter AccordionMultiselect -->
                                    <div class="mb-3">
                                        <label class="form-label">Audience Type</label>
                                        <AccordionMultiSelect
                                            :options="dest_list"
                                            v-model="filters.destination"
                                            @update:modelValue="handleFilterSelection"
                                            placeholder="Select audience types..."
                                        />
                                    </div>

                                    <!-- Archived Toggle -->
                                    <div class="form-check form-switch d-inline-flex align-items-center gap-2">
                                        <input class="form-check-input" type="checkbox" id="archivedSwitch"
                                                v-model="show_archived" @change="handleArchivedToggle" aria-label="Show Archived">
                                        <label class="form-check-label" for="archivedSwitch">Archived</label>
                                    </div>
                                </div>
                            </div>
                            <button v-if="canEdit('pathways') || canEdit('direct_mail')" type="button" class="btn btn-primary" @click="openDescribeSegmentModal">
                                <img class="icon" src="/img/icons/avid-icons/edna.svg" alt="">Add an Audience
                            </button>
                            <div v-else data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                <button class="btn btn-secondary" :disabled="true">
                                    <img class="icon" src="/img/icons/avid-icons/edna.svg" alt="">Add an Audience
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body p-0">
                <div class="table-width-responsive">
                    <table class="table table-with-pagination mb-0">
                        <thead>
                            <tr class="table-header-row">
                                <th class="d-none d-md-table-cell"  width="1" v-if="canEdit('pathways') || canEdit('direct_mail')">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="selectAll" :checked="select_all_checked" :indeterminate="someChecked" @change="toggleSelectAll($event)" ref="selectAllCheckbox" aria-label="Checkbox">
                                    </div>
                                </th>
                                <th @click="sortByKey('name')" class="d-table-cell">
                                    <div class="d-flex flex-row">
                                        Audience
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key==='name' && sort_order==='asc')? 'sort-key-active' :''" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key==='name' && sort_order==='des')? 'sort-key-active' :''" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th @click="sortByKey('type')" class="d-none d-md-table-cell" v-if="showSegmentTypeColumn">
                                    <div class="d-flex flex-row">
                                        Type
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key==='type' && sort_order==='asc')? 'sort-key-active' :''" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key==='type' && sort_order==='des')? 'sort-key-active' :''" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th @click="sortByKey('sizes')" class="d-none d-sm-table-cell">
                                    <div class="d-flex flex-row">
                                        Contacts <img class="info-icon" src="/img/icons/avid-icons/info.svg" data-bs-toggle="tooltip" title="The actual number of records synced to the destination will vary based what that system uses to determine unique records." alt=""></img>
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key==='sizes' && sort_order==='asc')? 'sort-key-active' :''" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key==='sizes' && sort_order==='des')? 'sort-key-active' :''" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th @click="sortByKey('data_source')" class="d-none d-sm-table-cell">
                                    <div class="d-flex flex-row">
                                        Data Source
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key==='data_source' && sort_order==='asc')? 'sort-key-active' :''" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key==='data_source' && sort_order==='des')? 'sort-key-active' :''" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th @click="sortByKey('pushed_pathways')" class="d-none d-sm-table-cell">
                                    <div class="d-flex flex-row">
                                        Usage
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key==='pushed_pathways' && sort_order==='asc')? 'sort-key-active' :''" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key==='pushed_pathways' && sort_order==='des')? 'sort-key-active' :''" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th @click="sortByKey('last_user_updated_by')" class="table-column-2 d-none d-lg-table-cell">
                                    <div class="d-flex flex-row">
                                        <span v-if="show_archived">Archived By</span>
                                        <span v-else>Updated By</span>
                                        <div class="d-flex flex-column">
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-up.svg" 
                                                :class="{ 'sort-key-active': sort_key === 'last_user_updated_by' && sort_order === 'asc' }" alt=""
                                            >
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-down.svg" 
                                                :class="{ 'sort-key-active': sort_key === 'last_user_updated_by' && sort_order === 'des' }" alt=""
                                            >
                                        </div>
                                    </div>
                                </th>
                                <th @click="sortByKey('last_user_updated_at')" class="table-column-2 d-none d-md-table-cell">
                                    <div class="d-flex flex-row">
                                        <span v-if="show_archived">Archived Date</span>
                                        <span v-else>Updated Date</span>
                                        <div class="d-flex flex-column">
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-up.svg" 
                                                :class="{ 'sort-key-active': sort_key === 'last_user_updated_at' && sort_order === 'asc' }" alt=""
                                            >
                                            <img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-down.svg" 
                                                :class="{ 'sort-key-active': sort_key === 'last_user_updated_at' && sort_order === 'des' }" alt=""
                                            >
                                        </div>
                                    </div>
                                </th>
                                <th class="d-table-cell column-sort-disabled pe-3" width="1" v-if="canEdit('pathways') || canEdit('direct_mail')">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(segment, index) in list_shown" :key="segment.id">
                                <td class="d-none d-md-table-cell" v-if="canEdit('pathways') || canEdit('direct_mail')">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" :value="segment.id" :id="'segment-' + segment.id" v-model="selected_segments" @change="updateSelectedCount()" aria-label="Selected Segments">
                                    </div>
                                </td>
                                <td class="d-table-cell">
                                    <Link class="text-wrap" :href="'/audience/' + client.url +'/' + segment.id" v-if="(canEdit('pathways') || canEdit('direct_mail')) && !isDeleted(segment)">
                                        {{ segment.name }}
                                    </Link>
                                    <span class="text-wrap" v-else-if="isDeleted(segment)">
                                        {{ segment.name }}
                                    </span>
                                    <span class="text-wrap" v-else>
                                        {{ segment.name }}
                                    </span>
                                </td>

                                <td class="d-none d-md-table-cell" v-if="showSegmentTypeColumn">
                                    <span class="badge badge-secondary">{{ propercase(segment.type || 'Owned') }}</span>
                                </td>
                                <td class="d-table-cell text-nowrap d-none d-sm-table-cell">
                                    <div class="d-flex align-items-center" v-if="segment.type == 'owned'">
                                        <span v-if="window_width < 577">
                                            {{ num_abbr(getDefaultSize(segment.sizes)) }} 
                                        </span>
                                        <span v-else>
                                            {{ number_with_zero(getDefaultSize(segment.sizes)) }} 
                                        </span>
                                            
                                    </div>
                                    <div class="d-flex align-items-center" v-else>--</div>
                                </td>
                                <td class="d-none d-sm-table-cell">
                                    {{ segment.data_source?segment.data_source.name : '' }}
                                </td>
                                <td class="d-none d-sm-table-cell">
                                    <template v-for="(pathway, index) in segment.pushed_pathways" :key="index">
                                        <span class="btn btn-white btn-icon-only-md me-2 my-1" v-if="pathway && pathway.conn_name && pathway.conn_name.indexOf('File') === -1" 
                                            data-bs-toggle="tooltip" :title="pathway.conn_name">
                                            <Link :href="'/pathways/' + client.url +'/manage_pathways?conn=' + pathway.conn_id + '&seg=' + segment.id+ '#conn-' + pathway.conn_id + '-segment-row-' + segment.id"
                                                v-if="canEdit('pathways') || canEdit('direct_mail')">
                                                <img :src="pathway.conn_icon" class="avatar-sm rounded-circle bg-white">
                                            </Link>
                                            <span v-else>
                                                <img :src="pathway.conn_icon" class="avatar-sm rounded-circle bg-white">
                                            </span>
                                        </span>
                                    </template>
                                    <span class="btn btn-white btn-icon-only-md" v-if="segment.analysis" data-bs-toggle="tooltip" title="Analysis Audience">
                                        <a href="#" @click.prevent="openAnalysisAudienceModal(segment)" data-bs-toggle="modal" :data-bs-target="'#analysis-segment-modal-'+ selected_segment.id"
                                            v-if="canEdit('pathways') || canEdit('direct_mail')">
                                            <img class="icon" src="/img/icons/avid-icons/favorite-chart.svg" alt="">
                                        </a>
                                        <span v-else>
                                            <img class="icon" src="/img/icons/avid-icons/favorite-chart.svg" alt="">
                                        </span>
                                    </span>

                                    <span class="btn btn-white btn-icon-only-md" v-if="segment.value_prop" data-bs-toggle="tooltip" title="Persona Audience">
                                        <a href="#" @click.prevent="openValuePropModal(segment)" data-bs-toggle="modal" :data-bs-target="'#value-prop-modal-'+ selected_segment.id"
                                            v-if="canEdit('pathways') || canEdit('direct_mail')">
                                            <img class="icon" src="/img/icons/avid-icons/profile.svg" alt="">
                                        </a>
                                        <span v-else>
                                            <img class="icon" src="/img/icons/avid-icons/profile.svg" alt="">
                                        </span>
                                    </span>
                                </td>
                                <td class="table-column-2 d-none d-lg-table-cell">
                                    <div class="user-info" v-if="show_archived">
                                        <img v-if="segment.deleted_by" :src="segment.deleted_by.image || segment.deleted_by.photo_url" class="avatar rounded-circle rounded-circle-primary-border bg-white" />
                                        <span>{{ segment.deleted_by?.first_name ?? '' }}</span>
                                    </div>
                                    <div class="user-info" v-else>
                                        <img v-if="lastUserUpdatedBy(segment)" :src="(lastUserUpdatedBy(segment).image || lastUserUpdatedBy(segment).photo_url)" class="avatar rounded-circle rounded-circle-primary-border bg-white" />
                                        <span>{{ lastUserUpdatedBy(segment) ? (lastUserUpdatedBy(segment).first_name ?? '') : '' }}</span>
                                    </div>
                                </td>
                                <td class="table-column-2 d-none d-md-table-cell">
                                    <span v-if="show_archived" :title="datetime(segment.deleted_at)" data-bs-toggle="tooltip">
                                        {{ date(segment.deleted_at) }}
                                    </span>
                                    <span v-else :title="datetime(lastUserUpdatedAt(segment))" data-bs-toggle="tooltip">
                                        {{ date(lastUserUpdatedAt(segment)) }}
                                    </span>
                                </td>
                                <td class="d-table-cell">
                                    <div class="dropdown d-flex justify-content-center" v-if="!show_archived">
                                        <button class="btn btn-white btn-icon-only-md" v-if="canEdit('pathways') || canEdit('direct_mail')" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false" aria-label="Button">
                                            <img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" data-bs-toggle="tooltip" title="Actions" alt="">
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                            <a class="dropdown-item" href="#" 
                                            v-if="isOwnedSegment(segment) && !segment.analysis && segment.source==='data_blend' && segment.data_source && segment.data_source.type==='constituent' && canEdit('pathways')"
                                            @click.prevent="openAnalysisAudienceModal(segment)" data-bs-toggle="modal" data-bs-auto-close="true" :data-bs-target="'#analysis-segment-modal-'+ selected_segment.id">
                                                <img class="icon me-2" src="/img/icons/avid-icons/diagram.svg" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Create Analysis Audience" alt="">
                                                <span v-if="!segment.analysis">Create an Analysis Audience</span>
                                                <span v-if="segment.analysis">Update the Analysis Audience</span>
                                            </a>
                                            <a class="dropdown-item" href="#" v-if="isOwnedSegment(segment) && canEdit('pathways')"
                                            @click.prevent="openValuePropModal(segment)" data-bs-toggle="modal" data-bs-auto-close="true" :data-bs-target="'#value-prop-modal-'+ selected_segment.id">
                                                <img class="icon me-2" src="/img/icons/avid-icons/profile.svg" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Edit Value Proposition" alt="">
                                                <span v-if="!segment.value_prop">Create a Persona Audience</span>
                                                <span v-if="segment.value_prop">Edit the Persona Audience</span>
                                            </a>
                                            <a class="dropdown-item" href="#" v-if="canCreateModeledAudience(segment)"
                                            @click.prevent="createModeledAudience(segment)">
                                                <img class="icon me-2" src="/img/icons/avid-icons/chart-square.svg" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Create a Modeled Audience" alt="">
                                                <span>Create a Modeled Audience</span>
                                            </a>

                                            <Link v-if="isOwnedSegment(segment) && export_connection_id && canExport('pathways')" class="dropdown-item" :href="'/pathways/' + client.url + '/' + segment.id + '/' + export_connection_id">
                                                <img class="icon me-2" src="/img/icons/avid-icons/file-download.svg" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Export Audience" alt="">
                                                <span>Export the Audience</span>
                                            </Link>
                                            <Link class="dropdown-item" v-if="isOwnedSegment(segment) && (canEdit('pathways') || canEdit('direct_mail'))" :href="'/audience/' + client.url +'/clone/' + segment.id">
                                                <img class="icon me-2" src="/img/icons/avid-icons/document-copy.svg" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Copy Audience" alt="">
                                                <span>Duplicate the Audience</span>
                                            </Link>
                                            <div class="dropdown-divider" v-if="isOwnedSegment(segment)"></div>
                                            <a class="dropdown-item text-danger" v-if="canEdit('pathways') || canEdit('direct_mail')" href="#" @click.prevent="deleteSegment(segment)">
                                                <img class="icon red-icon me-2" src="/img/icons/avid-icons/archive-2.svg" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Delete Audience" alt="">
                                                <span>Archive the Audience</span>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="dropdown d-flex justify-content-center" v-if="show_archived">
                                        <button class="btn btn-none p-2" @click.prevent="restoreSegment(segment)" data-bs-toggle="tooltip" title="Restore audience">
                                            <img class="pe-0" src="/img/icons/avid-icons/undo.svg" alt="">
                                        </button>
                                        
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot class="table-border-bottom-0">
                            <tr>
                                <td colspan="100%" class="py-0">
                                    <div class="table-pagination">
                                        <div class="table-pagination--group d-none d-md-flex">
                                            <div class="position-relative">
                                                <select class="form-select" name="num_per_page" id="num_per_page" v-model="num_per_page" @change="reloadPagination(filtered_segment_list)" aria-label="Num Per Page">
                                                    <option value="5000">ALL</option>
                                                    <option v-for="num in num_per_page_options" :key="num" :value="num">{{ num }}</option>
                                                </select>
                                                <div class="select-display-text">
                                                    Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="table-pagination--group d-none d-lg-flex">
                                            {{ filtered_segment_list.length === 0 ? '0' : item_interval }} of {{ filtered_segment_list.length }}
                                        </div>

                                        <div class="table-pagination--group">
                                            <button v-if="page_count>1" class="btn btn-secondary btn-icon-only-md me-1" @click="moveToPrevPage(filtered_segment_list)" :disabled="page_index === 0" data-bs-toggle="tooltip" title="Previous page">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-left.svg" alt="">
                                            </button>

                                            <div class="d-flex page-selector" v-if="page_index_array.length<=3">
                                                <button v-for="page in page_index_array" :key="page" class="btn btn-none btn-icon-only-md" :class="page === page_index + 1 ? 'current-page':''" @click="moveToPage(page, filtered_segment_list)">
                                                {{page}}
                                                </button>
                                            </div>
                                            <div class="d-flex page-selector" v-else>
                                                <button v-for="page in page_index_array.slice(0,2)" :key="page" class="btn btn-none btn-icon-only-md" :class="page === page_index + 1 ? 'current-page':''" @click="moveToPage(page, filtered_segment_list)">
                                                {{page}}
                                                </button>

                                                <button v-if="page_index > 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled>
                                                ...
                                                </button>
                                                <button v-if="page_index >= 2 && page_index< page_index_array.length -1" class="btn btn-none btn-icon-only-md current-page">
                                                    {{page_index + 1 }}
                                                </button>

                                                <button v-if="page_index < page_index_array.length -2" class="btn btn-none btn-icon-only-md text-nowrap" disabled aria-hidden="true">
                                                ...
                                                </button>
                                                <button :class="page_index === page_index_array.length -1 ? 'current-page':''" class="btn btn-none btn-icon-only-md" @click="moveToPage(page_index_array.length, filtered_segment_list)" :key="page_index_array.length">
                                                {{ page_index_array.length }}
                                                </button>
                                            </div>

                                            <button v-if="page_count>1" class="btn btn-secondary btn-icon-only-md ms-1" @click="moveToNextPage(filtered_segment_list)" :disabled="page_index === page_count -1" data-bs-toggle="tooltip" title="Next page">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-right.svg" alt="">
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>                    
                </div>

            </div>
        </div>

        <div class="modal fade" :id="'analysis-segment-modal-'+ selected_segment.id" aria-labelledby="analysis-segment-modal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom-0 pb-0">
                        <div class="text-center w-100">
                            <button type="button" class="btn btn-white float-end close-modal me-0" :data-bs-dismiss="'analysis-segment-modal-'+ selected_segment.id"
                                @click="closeModal('analysis-segment-modal-'+ selected_segment.id)" data-bs-toggle="tooltip" title="Close">
                                <img class="icon" src="/img/icons/avid-icons/close.svg" alt=""> 
                            </button>
                            <h3 class="mt-2">{{ modal_action }} Analysis Audience</h3>
                        </div>
                    </div>
                    <div class="modal-body pt-0 pb-0">
                        <analysis-segment-builder :client="client" :segment_selected="selected_segment" :modal_action="modal_action"
                        :if_allow_edit="canEdit('pathways')" @updated="analysisSegmentUpdated" @deleted="analysisSegmentDeleted"></analysis-segment-builder>
                    </div>
                </div>
            </div>
        </div>

        <DescribeSegmentModal
            ref="describeSegmentModalRef"
            :client="client"
            modal-id="pathways-describe-segment-modal"
            @submitted="onSegmentSuggestionSubmitted"
            @error="onSegmentSuggestionError"
        />
        <SegmentProposalModal
            v-if="client"
            ref="segmentProposalModalRef"
            :client="client"
            @saved="onSegmentProposalSaved"
        />

        <div class="modal fade" :id="'value-prop-modal-'+ selected_segment.id" aria-labelledby="value-prop-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header border-bottom-0 pb-0">
                        <div class="text-center w-100">
                            <button type="button" class="btn btn-white float-end close-modal me-0" :data-bs-dismiss="'value-prop-modal-'+ selected_segment.id"
                                @click="closeModal('value-prop-modal-'+ selected_segment.id)" data-bs-toggle="tooltip" title="Close">
                                <img class="icon" src="/img/icons/avid-icons/close.svg" alt=""> 
                            </button>
                            <h3 class="mt-2">Persona Audience</h3>
                        </div>
                    </div>
                    <div class="modal-body pt-0 pb-0">
                        <div class="form-group">
                            <label for="value_prop" class="form-label">What would motivate this audience to take action?</label>
                            <textarea :disabled="!canEdit('pathways')" class="form-control h-auto" v-model="value_prop" rows="8" placeholder="Enter a couple of sentences that would be helpful to know when drafting copy for this audience"></textarea>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" :data-bs-dismiss="'value-prop-modal-'+ selected_segment.id" @click="closeModal('value-prop-modal-'+ selected_segment.id)" :disabled="saving_value_prop">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="saveValueProp" :disabled="saving_value_prop || !canEdit('pathways')">
                            <span v-if="!saving_value_prop">Save</span>
                            <span v-else>
                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Saving...
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import tablePaginationMixin from '../../mixins/table_pagination';
    import permissionsMixin from '../../mixins/permissions';
    import AccordionMultiSelect from '../components/AccordionMultiSelect.vue';
    import DescribeSegmentModal from './DescribeSegmentModal.vue';
    import SegmentProposalModal from './SegmentProposalModal.vue';
    import { defineComponent } from 'vue';
    import { Link } from '@inertiajs/vue3';
    import { useNotifications } from '../../composables/useNotifications';
    import { useAISuggestionPolling, createSegmentSuggestionCheckFunction } from '../../composables/useAISuggestionPolling';

    export default defineComponent({
        components: {
            AccordionMultiSelect,
            DescribeSegmentModal,
            Link,
            SegmentProposalModal,
        },
        props: ['datasets', 'datablends', 'connection_datasets', 'client', 'segments', 'census_connections'],
        setup() {
            const { showNotification } = useNotifications();
            const { startPolling, stopPolling } = useAISuggestionPolling();
            return {
                showNotification,
                startPolling,
                stopPolling,
            };
        },
        mixins: [tablePaginationMixin, permissionsMixin],
        data() {
            return {
                local_segments: [],
                filtered_segment_list: [],
                list_shown:[],
                segment: {
                    name: '',
                    data_source_id: null,
                    filter: null
                },
                search_key: '',
                sort_key: null,
                sort_order: 'asc',
                filters: {},
                export_busy:[],
                export_connection_id: null,

                //analysis audience modal
                selected_segment: {},
                modal_action: '',
                value_prop: '',
                saving_value_prop: false,

                selected_segments: [],
                select_all_checked: false,

                window_width: window.innerWidth,
                show_archived: false,
            };
        },
        computed: {
            source_list() {
                // Get unique sources from segments, excluding modeled segments
                const usedSources = new Set();
                this.local_segments.forEach(seg => {
                    const segmentType = seg.type || 'owned';
                    if (segmentType !== 'modeled' && seg.data_source && seg.data_source.name) {
                        usedSources.add(seg.data_source.name);
                    }
                });
                return Array.from(usedSources).sort().map(source => ({
                    value: source,
                    text: source,
                    id: source
                }));
            },
            segment_type_list() {
                // Get unique segment types from segments
                const usedSegmentTypes = new Set();
                this.local_segments.forEach(seg => {
                    let segmentType = seg.type || 'owned';
                    // Propercase: first letter uppercase, rest lowercase
                    segmentType = segmentType.charAt(0).toUpperCase() + segmentType.slice(1).toLowerCase();
                    usedSegmentTypes.add(segmentType);
                });
                return Array.from(usedSegmentTypes).sort().map(type => ({
                    value: type.toLowerCase(),
                    text: type,
                    id: type.toLowerCase()
                }));
            },
            dest_list() {
                // Get unique audience types from segments
                const usedConnections = new Set();
                this.local_segments.forEach(seg => {
                    if (seg.pushed_pathways) {
                        seg.pushed_pathways.forEach(pathway => {
                            if (pathway && pathway.conn_name && pathway.conn_name.indexOf('File') === -1) {
                                usedConnections.add(pathway.conn_name);
                            }
                        });
                    }
                });

                // Add special audience types
                const destinations = Array.from(usedConnections);
                destinations.push('Analysis Audience');
                destinations.push('Persona Audience');

                return destinations.map(dest => ({
                    value: dest,
                    text: dest,
                    id: dest
                }));
            },
            someChecked() {
                if (this.list_shown.length === 0) return false;
                const selectedCurrentPageSegments = this.list_shown.filter(segment => this.selected_segments.includes(segment.id));
                return selectedCurrentPageSegments.length > 0 && selectedCurrentPageSegments.length < this.list_shown.length;
            },
            allSegmentsSelected() {
                if (this.filtered_segment_list.length === 0) return false;
                return this.selected_segments.length === this.filtered_segment_list.length &&
                       this.filtered_segment_list.every(segment => this.selected_segments.includes(segment.id));
            },
            showSegmentTypeFilter() {
                return this.segment_type_list.length > 1;
            },
            showSegmentTypeColumn() {
                return this.segment_type_list.length > 1;
            }
        },
        beforeMount() {
            this.local_segments = [...this.segments];
            this.filtered_segment_list = [...this.segments];

            //Loop through census connections and find the one that is a file
            this.connection_datasets.forEach(conn => {
                if(this.isFile(conn)){
                    this.export_connection_id = conn.id;
                }
            });

            this.reloadPagination(this.filtered_segment_list);
            this.setupFilter();
        },
        mounted() {
            this.$nextTick(() => {
                this.updateSelectedCount();
            });

            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

            for (var i = 0; i < tooltipTriggerList.length; i++) {
              (function(index) {
                tooltipTriggerList[index].addEventListener('click', function() {
                  // Hide the tooltip using the index passed to the closure
                  tooltipList[index].hide();
                });
                tooltipTriggerList[index].addEventListener('mouseleave', function() {
                  // Hide the tooltip using the index passed to the closure
                  tooltipList[index].hide();
                });
              })(i);
            }

            // Check for URL parameter to trigger value prop modal
            this.checkForValuePropModalTrigger();
        },
        beforeUnmount() {
            // Clean up tooltips
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            tooltipTriggerList.forEach(tooltipTriggerEl => {
                const tooltip = window.bootstrap.Tooltip.getInstance(tooltipTriggerEl);
                if (tooltip) {
                    tooltip.dispose();
                }
            });
        },
        watch: {
            list_shown() {
                // Update the select_all_checked state when the page changes
                this.updateSelectedCount();
            }
        },
        methods: {
            /** Last user who edited (not system/jobs). Handles both snake_case and camelCase from backend. */
            lastUserUpdatedBy(segment) {
                return segment?.last_user_updated_by_user ?? segment?.lastUserUpdatedByUser ?? null;
            },
            /** Date of last user edit; falls back to updated_at when migration not run or no user edit yet. */
            lastUserUpdatedAt(segment) {
                return segment?.last_user_updated_at ?? segment?.updated_at ?? null;
            },
            deletedBy(seg) {
                if (seg.deleted_by?.name === undefined) {
                    return 'Archived on ' + seg.deleted_at_formatted;
                }
                return 'Archived by ' + seg.deleted_by.name + ' on ' + seg.deleted_at_formatted;
            },
            isDeleted(seg) {
                return seg.deleted_at !== null && seg.deleted_at !== undefined;
            },
            isOwnedSegment(seg) {
                return (seg.type || 'owned') === 'owned';
            },
            hasModeledAudience(segment) {
                return this.local_segments.some(seg => (seg.type || 'owned') === 'modeled' && seg.data_source_id === segment.id);
            },
            canCreateModeledAudience(segment) {
                return this.isOwnedSegment(segment) && this.canEdit('pathways')
                    && this.getDefaultSize(segment.sizes) >= 1000
                    && !this.hasModeledAudience(segment);
            },
            createModeledAudience(segment) {
                const self = this;
                const name = segment.name + ' (Modeled)';
                window.axios.post('/api/segment/' + this.client.url, {
                    type: 'modeled',
                    data_source_id: segment.id,
                    name: name,
                    filter: { logic_units: [], filter_logic: '', filter_ui: 'simple', filter_option: 'custom', logic_units_modification: 0 }
                }).then(response => {
                    if (response.status === 200 && response.data.data) {
                        const newSegment = response.data.data;
                        self.showNotification({
                            text: '<strong>' + newSegment.name + '</strong> was successfully created.'
                        });
                        if (self.local_segments) {
                            self.local_segments.unshift(newSegment);
                            self.handleFilterSelection();
                            self.sortDataWithLabel();
                            self.reloadPagination(self.filtered_segment_list);
                        }
                    }
                }).catch(error => {
                    const message = error.response?.data?.error || 'Failed to create modeled audience.';
                    self.showNotification({ text: message, type: 'error' });
                });
            },
            isFile(conn) {
                return conn.integration_id == '71b0c3b0-8390-49ec-9984-1c04b7384d38';
            },
            getDefaultSize(sizes) {
                if(!sizes)
                    return null;
                for (var i = 0; i < sizes.length; i++){
                    if (sizes[i].id == 0)
                        return sizes[i].size;
                }
                return null
            },
            setupFilter(){
                // Initialize filters with no options selected (empty arrays)
                this.filters = {
                    source: [],
                    destination: [],
                    segment_type: []
                }
            },

            handleFilterSelection(){
                var filtered_list = [];

                if (this.local_segments.length === 0) {
                    return;
                }
                
                // If no filters are selected, show all items (only apply search filter)
                const noSourceFilter = this.filters.source.length === 0;
                const noDestinationFilter = this.filters.destination.length === 0;
                const noSegmentTypeFilter = this.filters.segment_type.length === 0;
                
                this.local_segments.forEach(seg => {

                    let data_source = seg.dataset ? seg.dataset : seg.datablend;
                    if(!data_source)
                        data_source = seg.data_source ? seg.data_source : {};

                    let in_search = this.search_key === '' || 
                        seg.name.toLowerCase().includes(this.search_key.toLowerCase());

                    // Check source filter (if any source filters are selected)
                    let source_match = noSourceFilter || this.filters.source.some(filter => filter.value === data_source.name);
                    
                    // Check segment type filter
                    const segmentType = seg.type || 'owned';
                    let segment_type_match = noSegmentTypeFilter || this.filters.segment_type.some(filter => filter.value === segmentType);
                    
                    if (in_search && source_match && segment_type_match) {
                        // Check destination filter
                        if (noDestinationFilter) {
                            // No destination filters selected, include all segments
                            filtered_list.push(seg);
                        } else {
                            // Check if segment matches any selected destination filters
                            let destination_match = false;
                            
                            this.filters.destination.forEach(dest => {
                                // Check special audience types
                                if (dest.value === 'Analysis Audience' && seg.analysis !== null) {
                                    destination_match = true;
                                } else if (dest.value === 'Persona Audience' && seg.value_prop !== null) {
                                    destination_match = true;
                                } else if (Array.isArray(seg.pushed_pathways) && seg.pushed_pathways.some(pathway => 
                                    pathway && pathway.conn_name && pathway.conn_name === dest.value
                                )) {
                                    destination_match = true;
                                }
                            });
                            
                            if (destination_match) {
                                filtered_list.push(seg);
                            }
                        }
                    }
                });

                this.filtered_segment_list = filtered_list;
                this.reloadPagination(this.filtered_segment_list);
                
                // Reset selection when filter changes
                this.selected_segments = [];
                this.select_all_checked = false;
                
                this.$forceUpdate();
            },
            handleArchivedToggle() {
                this.page_index = 0;

                // Fetch segments with archived filter
                window.axios.post(`/api/segment/${this.client.url}/search`, {
                    archived: this.show_archived
                }).then(response => {
                    // console.log(response.data.segments);
                    this.local_segments = response.data.segments;
                    this.filtered_segment_list = [...response.data.segments];
                    
                    // Reset filters and apply them to the new data
                    this.setupFilter();
                    this.handleFilterSelection();

                }).catch(error => {
                    console.error('Error fetching segments:', error);
                });
            },
            addNewSegment() {
                if(this.datablends.length > 0){
                    this.segment = {
                        id: null,
                        source: 'data_blend',
                        name: '',
                        data_source_id: this.datablends[0].id,
                        filter: null,
                        expires_at: null
                    };
                }
                else {
                    this.segment = {
                        id: null,
                        source: 'data_set',
                        name: '',
                        data_source_id: this.datasets[0].id,
                        filter: null,
                        expires_at: null
                    };
                }
            },
            addSegmentToDataSet(seg) {
                this.filtered_segment_list.push(seg);
                this.sortDataWithLabel();
                this.reloadPagination(this.filtered_segment_list);
            },
            updateSegmentToDataSet(seg) {
                var index = this.filtered_segment_list.findIndex(segment => segment.id == seg.id);
                this.filtered_segment_list[index] = seg;
                this.reloadPagination(this.filtered_segment_list);
            },
            editSegment(seg) {
                this.segment = seg;
            },
            deleteSegment(seg) {
                var self = this;

                //Show a warning
                Swal.fire({
                  title: "Are you sure you want to archive this audience?",
                  text: "The audience will no longer be available for data analysis and any connections with 3rd party systems will be removed.",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Yes, archive",
                  customClass: {
                    popup: 'swal-warning'
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    window.axios.delete('/api/segment/'+self.client.url + '/' + seg.id)
                        .then(response => {
                            if (response.status == 200) {
                                var index = this.filtered_segment_list.findIndex(segment => segment.id == seg.id);
                                this.filtered_segment_list.splice(index, 1);
                                this.reloadPagination(this.filtered_segment_list);

                                Swal.fire({
                                    title: "Archived!",
                                    text: "This audience has been archived.",
                                    icon: "success",
                                    customClass: {
                                        popup: 'swal-success'
                                    },
                                });
                            }
                        });
                  }
                });
            },
            sortByKey(key){
                this.sort_key = key;
                if (this.sort_key != key){
                    this.sort_order = 'asc'; // reset to ascending sorting order
                } else{
                    this.sort_order = (this.sort_order == 'asc'? 'des':'asc');
                }
                this.sortDataWithLabel();
            },
            sortDataWithLabel(){
                const sortKey = this.sort_key || 'name';
                const sortOrder = (this.sort_key != null && this.sort_key !== '') ? this.sort_order : 'asc';
                if (sortKey == 'data_source'){
                    if(sortOrder == 'asc')
                        this.filtered_segment_list.sort((a, b) => {
                            if (!a.data_source)
                                return -1;
                            if (!b.data_source)
                                return 1;
                            return (a.data_source.name > b.data_source.name) ? 1 : -1;
                        });
                    else
                        this.filtered_segment_list.sort((a, b) => {
                            if (!a.data_source)
                                return 1;
                            if (!b.data_source)
                                return -1;
                            return (a.data_source.name < b.data_source.name) ? 1 : -1;
                        });
                }
                else if(sortKey == 'sizes'){
                    if(sortOrder == 'asc')
                        this.filtered_segment_list.sort((a, b) => {
                            // Find element with id = 0 in 'a'
                            const aFound = (a[sortKey] == null) ? false : a[sortKey].find(item => item.id === 0);
                            const aValue = aFound ? aFound.size : 0;

                            // Find element with id = 0 in 'b'
                            const bFound = (b[sortKey] == null) ? false : b[sortKey].find(item => item.id === 0);
                            const bValue = bFound ? bFound.size : 0;

                            // Compare the size values
                            return aValue - bValue;
                        });
                    else
                        this.filtered_segment_list.sort((a, b) => {
                            // Find element with id = 0 in 'a'
                            const aFound = (a[sortKey] == null) ? false : a[sortKey].find(item => item.id === 0);
                            const aValue = aFound ? aFound.size : 0;

                            // Find element with id = 0 in 'b'
                            const bFound = (b[sortKey] == null) ? false : b[sortKey].find(item => item.id === 0);
                            const bValue = bFound ? bFound.size : 0;

                            // Compare the size values
                            return bValue - aValue;
                        });
                }else if(sortKey == 'pushed_pathways'){
                    // Sorting logic for the "Audience Types" column
                    const compareFn = (a, b) => {
                        const aTypes = this.getAudienceTypeNames(a);
                        const bTypes = this.getAudienceTypeNames(b);
                        // Primary sort: whether a segment has any audience types
                        if (aTypes.length === 0 && bTypes.length !== 0) return sortOrder === 'asc' ? -1 : 1;
                        if (aTypes.length !== 0 && bTypes.length === 0) return sortOrder === 'asc' ? 1 : -1;
                        // Secondary sort: alphabetical comparison of the concatenated names
                        const aKey = aTypes.join(', ');
                        const bKey = bTypes.join(', ');
                        return sortOrder === 'asc' ? aKey.localeCompare(bKey) : bKey.localeCompare(aKey);
                    };
                    this.filtered_segment_list.sort(compareFn);
                }else if(sortKey == 'type'){
                    // Sorting logic for the "Audience Type" column
                    if(sortOrder == 'asc')
                        this.filtered_segment_list.sort((a, b) => {
                            const aType = a.type || 'owned';
                            const bType = b.type || 'owned';
                            return aType.localeCompare(bType);
                        });
                    else
                        this.filtered_segment_list.sort((a, b) => {
                            const aType = a.type || 'owned';
                            const bType = b.type || 'owned';
                            return bType.localeCompare(aType);
                        });
                }else{
                    if(sortOrder == 'asc')
                        this.filtered_segment_list.sort((a, b) => (a[sortKey] > b[sortKey]) ? 1 : -1);
                    else
                        this.filtered_segment_list.sort((a, b) => (a[sortKey] < b[sortKey]) ? 1 : -1);
                }
                this.reloadPagination(this.filtered_segment_list);
            },
             /**
             * Build a sorted list of display names that appear in the "Audience Types" column
             * for a segment.  This includes:
             *  1. Each non-file connection name in pushed_pathways
             *  2. "Analysis Audience" when the segment has an analysis audience
             *  3. "Persona Audience" when the segment has a value proposition
             *
             * The returned list is already alphabetically sorted so it can be
             * converted to a single comparable key string when sorting.
             */
            getAudienceTypeNames(segment) {
                const names = [];
                // Add pathway connection names (skip File destinations)
                if (segment.pushed_pathways && Array.isArray(segment.pushed_pathways)) {
                    segment.pushed_pathways.forEach(pathway => {
                        if (pathway && pathway.conn_name && pathway.conn_name.indexOf('File') === -1) {
                            names.push(pathway.conn_name);
                        }
                    });
                }
                // Add special types
                if (segment.analysis) {
                    names.push('Analysis Audience');
                }
                if (segment.value_prop) {
                    names.push('Persona Audience');
                }
                // Sort alphabetically for stable comparisons
                return names.sort((a, b) => a.localeCompare(b));
            },
            closeModal(modal_ID){
                var myModalEl = document.getElementById(modal_ID)
                var modal = bootstrap.Modal.getInstance(myModalEl)
                modal.hide();
            },
            openAnalysisAudienceModal(segment){
                this.selected_segment = segment,
                this.modal_action = (!segment.analysis ? 'Add' : 'Update');
            },
            analysisSegmentUpdated(analysis_audience){
                this.closeModal('analysis-segment-modal-'+ this.selected_segment.id);
                this.showNotification({
                    text: '<strong>' + this.selected_segment.name + '</strong> was successfully saved!'
                });
                var index = this.filtered_segment_list.findIndex((seg) => seg.id == this.selected_segment.id);
                if (index !== -1) {
                    this.filtered_segment_list[index].analysis = analysis_audience;
                    this.reloadPagination(this.filtered_segment_list);
                }
            },
            analysisSegmentDeleted(){
                this.closeModal('analysis-segment-modal-'+ this.selected_segment.id);
                this.showNotification({
                    text: 'The analysis audience for <strong>' + this.selected_segment.name + '</strong> was deleted!'
                });
                var index = this.filtered_segment_list.findIndex((seg) => seg.id == this.selected_segment.id);
                if (index !== -1) {
                    this.filtered_segment_list[index].analysis = null;
                    this.reloadPagination(this.filtered_segment_list);
                }
            },
            openValuePropModal(segment) {
                this.selected_segment = segment;
                this.value_prop = segment.value_prop || '';
            },
            saveValueProp() {
                this.saving_value_prop = true;
                this.selected_segment.value_prop = this.value_prop;

                // Call the API to update the value proposition
                window.axios.put('/api/segment/'+this.client.url + '/' + this.selected_segment.id, this.selected_segment)
                    .then(response => {
                        this.closeModal('value-prop-modal-'+ this.selected_segment.id);
                        Swal.fire({
                            title: "Persona Audience Saved!",
                            text: "The persona audience has been updated successfully.",
                            icon: "success",
                            customClass: {
                                popup: 'swal-success'
                            },
                        }).then(() => {
                            // Update the table after the alert is shown
                            var index = this.filtered_segment_list.findIndex((seg) => seg.id == this.selected_segment.id);
                            if (index !== -1) {
                                this.filtered_segment_list[index].value_prop = this.value_prop;
                                this.reloadPagination(this.filtered_segment_list);
                            }
                        });
                    })
                    .catch(error => {
                        if (error.response.status == 400) {
                            Swal.fire({
                                title: "Error",
                                text: "There was an error updating the persona audience. Please try again later.",
                                icon: "error",
                                customClass: {
                                    popup: 'swal-error'
                                },
                            });
                        }
                    })
                    .finally(() => {
                        this.saving_value_prop = false;
                    });
            },
            toggleSelectAll(event) {
                // If some items are selected (indeterminate state) or all items are selected,
                // clicking the checkbox should deselect all items across all pages
                if (this.someChecked || this.allSegmentsSelected) {
                    // Clear all selections
                    this.selected_segments = [];

                    // Explicitly set the checkbox to unchecked state
                    this.select_all_checked = false;

                    // Force the checkbox to be unchecked
                    if (this.$refs.selectAllCheckbox) {
                        this.$refs.selectAllCheckbox.indeterminate = false;
                        this.$refs.selectAllCheckbox.checked = false;
                    }

                    // Prevent the default checkbox behavior
                    event.preventDefault();
                } else {
                    // Get the checked state directly from the event
                    const isChecked = event.target.checked;

                    // Get IDs of segments on the current page
                    const currentPageSegmentIds = this.list_shown.map(segment => segment.id);

                    if (isChecked) {
                        // Add all current page segment IDs to selected_segments if they're not already there
                        currentPageSegmentIds.forEach(id => {
                            if (!this.selected_segments.includes(id)) {
                                this.selected_segments.push(id);
                            }
                        });
                    } else {
                        // Remove all current page segment IDs from selected_segments
                        this.selected_segments = this.selected_segments.filter(id => !currentPageSegmentIds.includes(id));
                    }

                    // Update the select_all_checked state
                    this.select_all_checked = isChecked;
                }
            },
            toggleSelectAllInTable() {
                // Get all segment IDs across all pages
                const allSegmentIds = this.filtered_segment_list.map(segment => segment.id);

                if (this.allSegmentsSelected) {
                    // If all segments are already selected, deselect all
                    this.selected_segments = [];
                } else {
                    // Otherwise, select all segments
                    this.selected_segments = [...allSegmentIds];
                }

                // Update the select_all_checked state
                this.select_all_checked = this.selected_segments.length > 0;
            },
            deleteSelectedSegments() {
                var self = this;

                //Show a warning
                Swal.fire({
                  title: "Are you sure you want to archive these audiences?",
                  text: "The audiences will no longer be available for data analysis and any connections with 3rd party systems will be removed.",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Yes, delete",
                  customClass: {
                    popup: 'swal-warning'
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Delete each segment individually
                    const deletePromises = self.selected_segments.map(segmentId => 
                        window.axios.delete('/api/segment/' + self.client.url + '/' + segmentId)
                    );

                    Promise.all(deletePromises)
                        .then(responses => {
                            // Remove deleted segments from the list
                            self.filtered_segment_list = self.filtered_segment_list.filter(segment => !self.selected_segments.includes(segment.id));
                            self.selected_segments = [];
                            self.select_all_checked = false;
                            self.reloadPagination(self.filtered_segment_list);

                            Swal.fire({
                                title: "Archived!",
                                text: "These audiences have been archived.",
                                icon: "success",
                                customClass: {
                                    popup: 'swal-success'
                                },
                            });
                        })
                        .catch(error => {
                            Swal.fire({
                                title: "Error",
                                text: "There was an error archiving some audiences. Please try again.",
                                icon: "error",
                                customClass: {
                                    popup: 'swal-error'
                                },
                            });
                        });
                  }
                });
            },

            restoreSelectedSegments() {
                // Works in archived view to restore multiple audiences
                const self=this;
                if(this.selected_segments.length===0){return;}

                Swal.fire({
                  title:`Restore ${this.selected_segments.length} archived audience(s)?`,
                  icon:'question',
                  showCancelButton:true,
                  confirmButtonText:'Restore',
                  customClass:{popup:'swal-warning'}
                }).then(result=>{
                  if(!result.isConfirmed) return;

                  const restorePromises = self.selected_segments.map(id=>
                    window.axios.post(`/api/segment/${self.client.url}/restore/${id}`)
                  );

                  Promise.all(restorePromises).then(responses=>{
                      const restoredIds=self.selected_segments;
                      // Remove restored segments from current archived list
                      self.filtered_segment_list=self.filtered_segment_list.filter(seg=>!restoredIds.includes(seg.id));
                      self.local_segments=self.local_segments.filter(seg=>!restoredIds.includes(seg.id));
                      self.reloadPagination(self.filtered_segment_list);
                      self.selected_segments=[];
                      self.select_all_checked=false;

                      this.showNotification({
                        text: `${self.selected_segments.length} audiences were restored.`
                      });
                  });
                });
            },
            updateSelectedCount() {
                if (this.list_shown.length === 0) {
                    this.select_all_checked = false;
                    return;
                }

                const selectedCurrentPageSegments = this.list_shown.filter(segment => this.selected_segments.includes(segment.id));

                // Set select_all_checked based on whether all segments on the current page are selected
                this.select_all_checked = selectedCurrentPageSegments.length === this.list_shown.length;

                // Update the indeterminate state of the checkbox
                if (this.$refs.selectAllCheckbox) {
                    this.$refs.selectAllCheckbox.indeterminate = this.someChecked;
                }
            },
            restoreSegment(segment){
                window.axios.post(`/api/segment/${this.client.url}/restore/${segment.id}`)
                    .then(response => {
                        const seg = response.data.segment;
                        var index = this.filtered_segment_list.findIndex(segment => segment.id == seg.id);
                        this.filtered_segment_list.splice(index, 1);
                        this.reloadPagination(this.filtered_segment_list);
                        this.showNotification({
                            text: '<strong>' + seg.name + '</strong> was restored.'
                        });
                    });
            },
            openDescribeSegmentModal() {
                this.$refs.describeSegmentModalRef?.show();
            },
            onSegmentSuggestionSubmitted({ segment_suggestion_id }) {
                this.showNotification({
                    icon: '/img/icons/nav-icons/Edna.svg',
                    text: "We're creating your audience. You'll be notified when it's ready!",
                    type: 'info',
                    noDismiss: true,
                });
                const requestKey = `segment-suggestion-${segment_suggestion_id}`;
                this.startPolling({
                    requestKey,
                    checkFn: createSegmentSuggestionCheckFunction({
                        clientUrl: this.client.url,
                        segmentSuggestionId: segment_suggestion_id,
                    }),
                    onSuccess: (data) => {
                        this.showNotification({
                            icon: '/img/icons/nav-icons/Edna.svg',
                            text: "Your audience suggestion is ready. Click to view.",
                            type: 'success',
                            action: { type: 'openSegmentProposal', segment_suggestion_id: data.id },
                        });
                    },
                    onTimeout: () => {},
                });
            },
            onSegmentSuggestionError(message) {
                this.showNotification({ text: message || 'Failed to submit.', type: 'error' });
            },
            onSegmentProposalSaved({ segment }) {
                if (segment && this.local_segments) {
                    this.local_segments.unshift(segment);
                    this.handleFilterSelection();
                }
            },
            checkForValuePropModalTrigger() {
                // Check if URL has show_value_prop parameter
                const urlParams = new URLSearchParams(window.location.search);
                if (urlParams.get('show_value_prop') === 'true') {
                    // Find the first segment that doesn't have a value prop to show the modal for
                    const segmentWithoutValueProp = this.filtered_segment_list.find(segment => !segment.value_prop);
                    
                    if (segmentWithoutValueProp) {
                        // Open the value prop modal for this segment
                        this.openValuePropModal(segmentWithoutValueProp);
                        
                        // Show the modal using Bootstrap
                        this.$nextTick(() => {
                            const modalElement = document.getElementById(`value-prop-modal-${segmentWithoutValueProp.id}`);
                            if (modalElement) {
                                const modal = new window.bootstrap.Modal(modalElement);
                                modal.show();
                            }
                        });
                        
                        // Clean up the URL parameter
                        urlParams.delete('show_value_prop');
                        const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
                        window.history.replaceState({}, '', newUrl);
                    }
                }
            },
        }
    });
</script>
